export const REDUX_ADD_USER_MESSAGE = 'REDUX_ADD_USER_MESSAGE'
export const REDUX_ADD_BOT_MESSAGE = 'REDUX_ADD_BOT_MESSAGE'
export const REDUX_SET_TYPING = 'REDUX_SET_TYPING'
export const REDUX_CLEAR_CHAT = 'REDUX_CLEAR_CHAT'
export const REDUX_UPDATE_MESSAGE_STATUS = 'REDUX_UPDATE_MESSAGE_STATUS'
export const REDUX_SET_MESSAGE_UNDERSTOOD_AS = 'REDUX_SET_MESSAGE_UNDERSTOOD_AS'
export const REDUX_ADD_CONVERSATION_HISTORY = 'REDUX_ADD_CONVERSATION_HISTORY'
export const REDUX_REMOVE_CHAT_MESSAGE = 'REDUX_REMOVE_CHAT_MESSAGE'
export const REDUX_SET_MENU_STATE = 'REDUX_SET_MENU_STATE'
export const REDUX_RESET_MENU_STATE = 'REDUX_RESET_MENU_STATE'
export const REDUX_SET_SELECTED_MENU_PATH = 'REDUX_SET_SELECTED_MENU_PATH'
export const REDUX_RESTORE_CHAT_SESSION = 'REDUX_RESTORE_CHAT_SESSION'
